// extracted by mini-css-extract-plugin
module.exports = {"activeOption":"lo","option":"lp","phone":"lq","value":"lr","text":"ls","label":"lt","list":"lu","centerMenu":"lv","active":"lw"};